import { Box, Typography, Rating, Stack } from '@mui/material'
import { Image, ImageData } from '@media-components'
import { publicImages } from '@utils/shared'
import { CustomStyles, getStyles } from '@utils/styles'
import { LinkClick } from '../LinkClick'
import defaultStyles, { StyleClassNames } from './styles'

export type TestimonialReviewCardData = {
  name: string
  designation?: string
  imageData?: ImageData
  heading: string
  description: string
  rating: number
  linkedinUrl?: string
}

export type TestimonialReviewCardProps = TestimonialReviewCardData & {
  csx?: CustomStyles<StyleClassNames>
  darkBg?: boolean
}

export function TestimonialReviewCard({
  imageData = {
    src: '/images/profile-placeholder-temp.png',
    alt: 'profile image',
  },
  name,
  designation,
  description,
  heading,
  rating,
  linkedinUrl,
  csx,
  darkBg = false,
}: TestimonialReviewCardProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <Box
      {...styles('wrapper', {
        backgroundColor: darkBg ? 'background.paperDark' : 'background.paper',
        borderColor: 'border.dark',
      })}
    >
      <Stack gap={1} className="content-section">
        <Image
          src={publicImages.quoteIcon}
          alt="quote icon"
          {...styles('icon')}
        />
        <Rating defaultValue={rating} readOnly />
        <Typography
          variant="h6.500"
          color={darkBg ? 'text.primaryDark' : 'text.primary'}
        >
          {heading}
        </Typography>
        <Typography
          variant="body1.400"
          color={darkBg ? 'text.primaryDark' : 'text.primary'}
        >
          {description}
        </Typography>
      </Stack>
      <Box {...styles('infoWrapper')}>
        <Image {...imageData} {...styles('image')} />
        <Box {...styles('info')}>
          <Typography
            variant="body1.500"
            color={darkBg ? 'text.primaryDark' : 'text.primary'}
          >
            {name}
          </Typography>
          {designation && (
            <Typography
              variant="body3.500"
              color={darkBg ? 'text.secondaryDark' : 'text.secondary'}
            >
              {designation}
            </Typography>
          )}
          {linkedinUrl && (
            <LinkClick link={linkedinUrl} newTab>
              <Image
                style={{
                  objectFit: 'contain',
                }}
                src={publicImages.linkedIcon}
                alt="bigohtech-logo"
                {...styles('linkedIcon')}
              />
            </LinkClick>
          )}
        </Box>
      </Box>
    </Box>
  )
}
